<script setup lang="ts">
import { ref, h } from "vue";
import { hasClass } from "@zyzgroup/core-web";
import Routes, { SupportedRouteEffect } from "../base/Routes.vue";
import Pop from "../pop/Pop.vue";
import Image from "./Image.vue";
import Pan from "../base/Pan.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Image, Routes },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    urls: string[];
    effect?: SupportedRouteEffect;
  }>(),
  {
    urls: () => [],
    effect: "moveToLeft"
  }
);

const emits = defineEmits<{
  // (event: "click"): void;
}>();

const currentIndex = ref(0);
function routeChangeEnd(fromPageIndex: number, toPageIndex: number) {
  currentIndex.value = toPageIndex;
}

const routesRef = ref();

const popOpen = () => {
  routesRef.value?.reset(
    props.urls.map((url) => ({
      component: h(Image, {
        mode: "aspectFit",
        src: url,
        openImageDetailWhenClick: false
      })
    }))
  );
};

const panLeft = () => {
  routesRef.value?.forward().catch((e) => {
    // console.log(e);
  });
};
const panRight = () => {
  routesRef.value?.back().catch((e) => {
    // console.log(e);
  });
};

const popRef = ref();
function open() {
  popRef.value?.open();
}
function close() {
  popRef.value?.close();
}

const checkClose = (e: Event) => {
  // console.log(e.target);
  if (e.target && hasClass(e.target as HTMLElement, "image")) {
    close();
  }
};

defineExpose({ open, close });
</script>

<template>
  <Pop
    ref="popRef"
    directionFrom="full"
    @open="popOpen"
    @click="checkClose"
  >
    <div
      v-if="props.urls.length > 1"
      style="
        position: absolute;
        top: 30px;
        left: 50%;
        transform: translate(-50%, 0);
        color: #ffffff;
        font-size: 1em;
        z-index: 98;
      "
    >
      {{ currentIndex + 1 }} / {{ props.urls.length }}
    </div>
    <Pan
      style="position: absolute; width: 100%; height: 100%; z-index: 97"
      @left="panLeft"
      @right="panRight"
    >
      <Routes
        ref="routesRef"
        :effect="props.effect"
        @routeChangeEnd="routeChangeEnd"
      />
    </Pan>
  </Pop>
</template>
